import React, { useState, useContext, useEffect } from 'react';
import { Col, FormControl, Modal } from 'react-bootstrap';
import {
  Card, CardBody, CardTitleWrap, CardSubhead,
} from '@/shared/components/Card';
import { Button } from '@/shared/components/Button';
import TablePagination from '@mui/material/TablePagination';
import {
  DropdownMenu, Dropdown, DropdownItem, DropdownToggle,
} from '@/shared/components/Dropdown';
import toast from 'react-hot-toast';
import { FaArrowUpShortWide, FaArrowDownWideShort } from 'react-icons/fa6';
import { size } from 'polished';
import { Table } from '@/shared/components/TableElements';
import AddUser from './AddUsers';
import EditUser from './EditUser';
import { AuthContext } from '../../../../../context/AuthContext';
import { GlobalContext } from '../../../../../context/GlobalContext';
import DeleteModal from './DeleteModal';
import mySimpleCrypt from '../../../Cracker';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';

const ResponsiveTable = () => {
  const { apiGlobal } = useContext(GlobalContext);
  const { agentId } = useContext(AuthContext); 
  const [refresh, setRefresh] = useState(false);

  const [userData, setUserData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [holdIDforDelete, setHoldIDforDelete] = useState('');
  const [userDataForEdit, setUserDataForEdit] = useState({});
  const [sortOrder, setSortOrder] = useState('asc');
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
   const [page, setPage] = React.useState(0);
   const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

   const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchUserData = async () => {
     const formData = new FormData();
    formData.append('agent_id', agentId);
    try {
      const response = await fetch(`${apiGlobal}/agent/user_agent_data.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.status && data.message === 'Success') {
        setUserData(data.data);
        setFilteredData(data.data);
      } else {
        setUserData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [agentId, refresh, sideBarRefresh?.agentUserRefresh]);

  useEffect(() => {
    const query = searchQuery.toLowerCase();
    setFilteredData(
      userData.filter(user => user.name.toLowerCase().includes(query) 
      || user.username.toLowerCase().includes(query)),
    );
  }, [searchQuery, userData]);

  const handleStatusToggle = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === '1' ? '0' : '1';
      const formData = new FormData();
      formData.append('id', userId);
      formData.append('agent_id', agentId);
      formData.append('status', newStatus);
      

      const response = await fetch(`${apiGlobal}/agent/user_agent_status.php`, {
          method: 'POST',
          body: formData,
        });
      const data = await response.json();
      if (data.status) {
        toast.success(data.message);
        fetchUserData();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error toggling status:', error);
    }
  };


const [sortColumn, setSortColumn] = useState('name'); // This will track the column being sorted
 
const handleSort = (column) => {
  const newSortOrder = sortColumn === column 
  && sortOrder === 'asc' ? 'desc' : 'asc'; // Toggle order for the same column

  const sortedData = [...filteredData].sort((a, b) => {
    if (column === 'name') {
      return newSortOrder === 'asc'
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name);
    }
    if (column === 'username') {
      return newSortOrder === 'asc'
        ? a.username.localeCompare(b.username)
        : b.username.localeCompare(a.username);
    }
    if (column === 'status') {
      return newSortOrder === 'asc' ? a.status - b.status : b.status - a.status;
    }
    return 0;
  });

  setSortColumn(column);
  setSortOrder(newSortOrder);
  setFilteredData(sortedData);
};
  const handleAddUser = async (user) => {
    if (!user.countryCode) {
      toast.error('Please select a country code');
      return;
    }
    try {
      const formData = new FormData();
      Object.entries(user).forEach(([key, value]) => formData.append(key, value));
      formData.append('country_code', user.countryCode?.value);
      formData.append('agent_id', agentId);

      const response = await fetch(`${apiGlobal}/agent/user_agent_add.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.status && data.message === 'Success') {
        toast.success('User added successfully');
        setShowModal(false);
        fetchUserData();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error adding user:', error);
    }
  };
 
  // eslint-disable-next-line
  const handleEditUser = (id, name, username,countryCode, country_code_id, designation, password, mobile1, mobile2) => {
    setShowModalEdit(true);
    setUserDataForEdit({
       // eslint-disable-next-line
      id, name, username, countryCode, country_code_id, designation, password, mobile1, mobile2,
    });
  };

  const editUserHandler = async (values) => {
    // console.log(JSON.stringify(values, null, 2));
    try {
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => formData.append(key, value));
      formData.append('country_code', values.country_code_id);
      const url = await fetch(`${apiGlobal}/agent/user_agent_edit.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await url.json();
      if (data.status && data.message === 'Record updated successfully.') {
        toast.success('User updated successfully.');
        setShowModalEdit(false);
        fetchUserData();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error('Error updating user:', error);
    } 
  };


  const handleDeleteModal = (id) => {
    setdeleteModalShow(true);
    setHoldIDforDelete(id);
  };

  const handleDeleteUser = async () => {
     const formData = new FormData();
     formData.append('id', holdIDforDelete);
    try {
      const url = await fetch(`${apiGlobal}/agent/user_agent_delete.php`, {
        method: 'POST',
        body: formData,
      });
      const data = await url.json();
      if (data.status && data.message === 'Data deleted successfully') {
        toast.success('User deleted successfully');
        setdeleteModalShow(false);
        setHoldIDforDelete('');
        fetchUserData();
    } else {
      toast.error(data.message);
    }
  } catch (error) {
    console.error('Error deleting user:', error);
  }
};

  const renderTableRows = () => {
    const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentRows = filteredData.slice(startIndex, endIndex);

  return (
    currentRows.map((user, index) => (
      <tr key={user.id}>
        <td>{index + 1}</td>
        <td>{user?.name}</td>
        <td>{user?.username}</td>
        <td>
          {user.status === '1' ? (
            <span className="bg-success text-white p-1 rounded">
              <i className="lnr lnr-checkmark-circle" /> Approved
            </span>
          ) : (
            <span className="bg-danger text-white p-1 rounded">
              <i className="lnr lnr-cross-circle" /> Not Approved
            </span>
          )}
        </td>
 
        <td>
          {user.type === '1' && (
            <Dropdown dir="ltr">
              <DropdownToggle
                variant="outline-primary"
                size="sm"
                style={{
                  fontSize: '12px', // Set text size
                  padding: '10px 20px', // Adjust padding to make it small
                  borderRadius: '40px', // Make it fully rounded
                }}
              >
                Actions
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => handleStatusToggle(user.id, user.status)}>
                  {user.status === '1' ? 'Mark as Not Approved' : 'Mark as Approved'}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )}
        </td>
        <td>
          <Button
            variant="success"
            title="Edit"
            size="sm"
            onClick={() => handleEditUser(
              user?.id, 
              user?.name,
              user?.username,
              user?.country_code,
              user?.country_code_id,
              user?.designation,
              user?.password,
              user?.mobile1,
              user?.mobile2,
              )}
          >
            <span className="lnr lnr-pencil" />
          </Button>
          {user.type === '1' && (
            <Button 
              variant="danger"
              size="sm" 
              title="Delete"
              onClick={() => handleDeleteModal(user.id)}
            >
              <span className="lnr lnr-trash" />
            </Button>
          )}
        </td>
      </tr>
    ))
  );
  }; 
  

  if (isLoading) return <div>Loading...</div>;

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <CardTitleWrap>
            <CardSubhead>
              All Users <span className="red-text">Bitevize-Agent</span>
              <Button
                style={{ float: 'right' }}
                variant="primary"
                size="sm"
                onClick={() => setShowModal(true)}
              >
                Add User
              </Button>
            </CardSubhead>
            <div className="d-flex">
              <FormControl
                type="text"
                placeholder="Search by name or username"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                style={{ width: '30%', marginTop: '10px' }}
              />
              <Button
                variant="outline-danger"
                style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '2px',
            alignSelf: 'center',
          }}
                className="mt-3 mx-2"
                onClick={() => {
            setRefresh(prev => !prev);
            toast.success('Data has been refreshed successfully');
          }}
              >
                Refresh
              </Button>
            </div>
           
          </CardTitleWrap>
          <TablePagination
            component="div"
            count={filteredData.length} // Total items after filter
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <Table responsive bordered>
            <thead>
              <tr>
                <th>Sr no.</th>
                <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                  Name {sortColumn === 'name' 
                  && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
                </th>
                <th onClick={() => handleSort('username')} style={{ cursor: 'pointer' }}>
                  Username {sortColumn === 'username' 
                  && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
                </th>               
                <th onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
                  Status {sortColumn === 'status' 
                  && (sortOrder === 'asc' ? <FaArrowUpShortWide /> : <FaArrowDownWideShort />)}
                </th>
                <th>Action</th>
                <th>Edit/Delete</th>
              </tr>
            </thead>
            <tbody>{renderTableRows()}</tbody>
          </Table>
        </CardBody>

        {/* Add User Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Add User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddUser onSubmit={handleAddUser} />
          </Modal.Body>
        </Modal>
          
        {/* Edit User Modal */}
        <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} centered size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Edit User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditUser userDetails={userDataForEdit} onSubmit={editUserHandler} />
          </Modal.Body>
        </Modal>

        {/* Delete User Modal */}
        <DeleteModal
          show={deleteModalShow}
          handleClose={() => setdeleteModalShow(false)}
          handleDelete={handleDeleteUser}
          message="Are you sure you want to delete this User?"
        />
      </Card>
    </Col>
  );
};

export default ResponsiveTable;
